import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Stack,
  Divider,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InfoRow = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mb={1.5}>
    <Typography variant="body2" fontWeight="bold" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" color="text.primary">
      {value || "—"}
    </Typography>
  </Box>
);

const BankDetailsModal = ({ open, onClose, paymentData }) => {
  const details = paymentData?.payment;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography fontSize="1.2rem" fontWeight={600}>
          Bank Details
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* Profile image and state */}
        <Box textAlign="center" mb={3}>
          <Avatar
            src={paymentData?.userImage}
            alt="User Image"
            sx={{ width: 80, height: 80, margin: "0 auto", mb: 1 }}
          />
          {paymentData?.state && (
            <Typography variant="subtitle2" color="text.secondary">
              State:{" "}
              <Typography
                component="span"
                variant="subtitle2"
                fontWeight={600}
                color="text.primary"
              >
                {paymentData?.state || "—"}
              </Typography>
            </Typography>
          )}
        </Box>

        {/* Bank details */}
        {details ? (
          <Stack spacing={1.5}>
            <InfoRow label="Full Name" value={details.fullName} />
            <Divider />
            <InfoRow label="Bank Name" value={details.bankName} />
            <Divider />
            <InfoRow label="Account Number" value={details.accountNumber} />
            <Divider />
            <InfoRow label="Confirm Account" value={details.confirmAccountNumber} />
            <Divider />
            <InfoRow label="Mobile Number" value={details.accountMobileNumber} />
            <Divider />
            <InfoRow label="Country Code" value={details.countryCode} />
          </Stack>
        ) : (
          <Typography color="text.secondary" textAlign="center" mt={2}>
            No bank details available for this user.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BankDetailsModal;
